import { render, staticRenderFns } from "./RealEstateEditTwo.vue?vue&type=template&id=ca7014cc&scoped=true"
import script from "./RealEstateEditTwo.vue?vue&type=script&lang=js"
export * from "./RealEstateEditTwo.vue?vue&type=script&lang=js"
import style0 from "./RealEstateEditTwo.vue?vue&type=style&index=0&id=ca7014cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca7014cc",
  null
  
)

export default component.exports